import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LeftOutlined } from "@ant-design/icons";

import {
  Layout,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  DatePicker,
  Col,
  InputNumber,
  Divider,
  Button,
  Modal,
  List,
  Spin,
} from "antd";
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";
import MainLayout from "../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
import CustomButton from "../../../../../components/custom/CustomButton";
import dayjs from "dayjs";
import TextArea from "antd/es/input/TextArea";

const { Text } = Typography;

const LoanPrepayment = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [hasFees, setHasFees] = useState(false);
  const [prepaymentOptionsData, setPrepaymentOptionsData] = useState([]);
  const [paymentTypeData, setPaymentTypeData] = useState([]);

  useEffect(() => {
    getTemplate();
  }, []);

  function getTemplate() {
    const params = {
      command: "prepayLoan",
    };
    const url = `${apiConfig.LoanAccounts}/${state.id}/transactions/template`;

    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;
        if (objList?.feeChargesPortion > 0) {
          setHasFees(true);
        }
        let tempPrepaymentOptions = [];
        let tempPaymentTypeData = [];

        objList?.paymentTypeOptions?.forEach((element) => {
          tempPaymentTypeData.push({
            value: element.id,
            label: element.name,
          });
        });

        setPrepaymentOptionsData(tempPrepaymentOptions);
        setPaymentTypeData(tempPaymentTypeData);

        useForm.setFieldsValue({
          transactionAmount: objList?.amount,
          principalPortion: objList?.principalPortion,
          transactionDate: dayjs(BOM.FormatArrayDateWithoutYear(objList?.date)),
          interestPortion: objList?.interestPortion,
          paymentTypeId: objList?.paymentTypeOptions[0].name,
          feeChargesPortion: objList?.feeChargesPortion,
        });
      }
    });
  }

  function onCancel() {
    navigate("/detail-loan-account", { state: state });
  }

  const onSubmit = (formValues) => {
    delete formValues.principalPortion;
    delete formValues.interestPortion;
    delete formValues.feeChargesPortion;

    formValues.transactionDate = BOM.DateTime(
      formValues.transactionDate,
      "only-date"
    );

    const params = {
      command: "repayment",
    };
    const url = `${apiConfig.LoanAccounts}/${state.id}/transactions`;

    const body = {
      ...formValues,
      locale: "en",
      method: "POST",
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      session,
      params,
    };

    // return
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.LoanPrepaymentMsg);
        navigate("/detail-loan-account", { state: state });
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };
  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.loanPrepayment}
        pageItems={staticConfig.loanPrepaymentBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          title={
            <Row
              style={{
                alignContent: "center",
                width: "8%",
              }}
            >
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
                onClick={onCancel}
              >
                <Text
                  style={{
                    marginTop: "auto",
                    marginBottom: "auto",
                    fontSize: 15,
                  }}
                >
                  Back
                </Text>
              </Button>
            </Row>
          }
        >
          <Form form={useForm} layout="vertical" onFinish={onSubmit}>
            <Row>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.transactionDate}
                  name="transactionDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.transactionDate),
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.transactionDate}`,
                      "select"
                    )}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.transactionAmount}
                  name="transactionAmount"
                >
                  <InputNumber
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.transactionAmount}`,
                      "select"
                    )}
                    style={{ width: "100%" }}
                    formatter={BOM.FormatAmount}
                    parser={BOM.ParseAmount}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.principal}
                  name={"principalPortion"}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.principal
                    )}
                    disabled
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.interestAmount}
                  name={"interestPortion"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.interestPortion),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.interestAmount
                    )}
                    disabled
                  />
                </Form.Item>
              </Col>

              {hasFees && (
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item label={labelConfig.fees} name="feeChargesPortion">
                    <Input
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.fees)}
                      disabled
                    />
                  </Form.Item>
                </Col>
              )}

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.paymentTypes}
                  name={"paymentTypeId"}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.paymentTypes,
                      "select"
                    )}
                    options={paymentTypeData}
                    showSearch
                  />
                </Form.Item>
              </Col>

              <Divider orientation="left" orientationMargin="0">
                {"Show Payment Details"}
              </Divider>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.accountNumber}
                  name="accountNumber"
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.accountNumber}`,
                      "select"
                    )}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.chequeNumber} name="checkNumber">
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.chequeNumber}`,
                      "select"
                    )}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.routingCode} name="routingCode">
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.routingCode}`,
                      "select"
                    )}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.receiptNumber}
                  name="receiptNumber"
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.receiptNumber}`,
                      "select"
                    )}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.bankNumber} name="bankNumber">
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.bankNumber}`,
                      "select"
                    )}
                  />
                </Form.Item>
              </Col>

              <Divider orientation="left" orientationMargin="0"></Divider>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.note} name={"note"}>
                  <TextArea
                    style={{ width: "100%", height: "10vh" }}
                    placeholder="Please enter a note"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Divider />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#15CCAE"
                colorText="black"
                hoverBackground="#4FECA0"
              />

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default LoanPrepayment;
